import HeadlessTable from '@/src/Common/components/HeadlessTable';
import { format } from 'date-fns';
import { Badge } from '@/src/shadComponents/ui/badge';
const statuses: any = {
    Completed: 'text-green-700 bg-green-50 ring-green-600/20',
    Sent: 'text-muted-foreground bg-muted/50 ring-gray-500/10',
    'In Progress': 'text-red-700 bg-red-50 ring-red-600/10',
    Unopened: 'text-red-700 bg-red-50 ring-red-600/10',
};

function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(' ');
}
const documents = [
    {
        title: 'Logistics Form',
        status: 'Completed',
        sentOn: new Date(),
        completedOn: new Date(),
        client: 'Peter Griffen',
        ownerName: 'Aubrey McCoy',
        id: 1,
        completedPercentage: '100%',
    },
];

export default function ActivationDocuments() {
    return (
        <HeadlessTable>
            {documents.map((document) => {
                return (
                    <tr key={document.id}>
                        <td className="relative">
                            <div className="flex gap-x-6 mr-5">
                                <div className="text-sm font-medium leading-6 text-foreground">
                                    {document.title}
                                </div>
                                {document.status ? (
                                    <Badge variant={document.status === 'Completed' ? 'default' : 'secondary'}>
                                        {document.status}
                                    </Badge>
                                ) : null}
                            </div>
                        </td>

                        <td className="hidden py-5 pr-6 sm:table-cell">
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                Sent To{' '}
                                <span className="text-foreground">
                                    {document.client}
                                </span>
                            </div>
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                Sent By{' '}
                                <span className="text-foreground">
                                    {document.ownerName}
                                </span>
                            </div>
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                Sent On{' '}
                                <span className="text-foreground">
                                    {format(document.sentOn, 'MM/dd/yyyy')}
                                </span>
                            </div>
                        </td>

                        <td className="hidden py-5 pr-6 sm:table-cell">
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                Last Viewed{' '}
                                <span className="text-foreground">
                                    {format(document.sentOn, 'MM/dd/yyyy')}
                                </span>
                            </div>
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                <span className="text-foreground">
                                    {document.completedPercentage}
                                </span>{' '}
                                Completed
                            </div>
                            <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                Completed On{' '}
                                <span className="text-foreground">
                                    {format(document.completedOn, 'MM/dd/yyyy')}
                                </span>
                            </div>
                        </td>

                        <td className="py-5 text-right">
                            <div className="flex justify-end">
                                <a
                                    href={`/documents/${document.id}`}
                                    className="text-sm font-medium leading-6 text-primary hover:underline"
                                >
                                    View
                                    <span className="hidden sm:inline">
                                        {' '}
                                        Document &rarr;
                                    </span>
                                </a>
                            </div>
                        </td>
                    </tr>
                );
            })}
        </HeadlessTable>
    );
}
